"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ItemPageParams = require("./ItemPageParams");
Object.keys(_ItemPageParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ItemPageParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ItemPageParams[key];
    }
  });
});
var _Language = require("./Language");
Object.keys(_Language).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Language[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Language[key];
    }
  });
});
var _LanguageSwitcherPopupProps = require("./LanguageSwitcherPopupProps");
Object.keys(_LanguageSwitcherPopupProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LanguageSwitcherPopupProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageSwitcherPopupProps[key];
    }
  });
});
var _LanguageSelectPopupTestIds = require("./LanguageSelectPopupTestIds");
Object.keys(_LanguageSelectPopupTestIds).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LanguageSelectPopupTestIds[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageSelectPopupTestIds[key];
    }
  });
});
var _OnLanguageChangeCallback = require("./OnLanguageChangeCallback");
Object.keys(_OnLanguageChangeCallback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnLanguageChangeCallback[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OnLanguageChangeCallback[key];
    }
  });
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});
var _Translations = require("./Translations");
Object.keys(_Translations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Translations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Translations[key];
    }
  });
});
